export function customerShowValidate(customer){
    var result = true;

    result = validateId(customer.id);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}